<template>
  <h2 class="accordion-header">
    <button class="accordion-button collapsed w-100 border-top border-primary" type="button" data-bs-toggle="collapse"
    :data-bs-target="`#collapse${incident.id}`" aria-expanded="false"
    :aria-controls="`collapse${incident.id}`">
      <div class="container-fluid p-0">
        <div class="row w-100">
          <div class="col">{{ incident.id }}</div>
          <div class="col">{{ incident.expendeduria_name }}</div>
          <div class="col">{{ incident.maquina_name }}</div>
          <div class="col"><span 
        class="badge rounded-pill"
        :class="incident.is_resolved ? 'bg-success' : 'bg-danger'"
      >
        {{ incident.is_resolved ? 'Resuelto' : 'Pendiente' }}
      </span></div>
          <div class="col">{{ formatDateTime(incident.incident_date, incident.incident_time) }}</div>  
        </div>
      </div>
    </button>
  </h2>
  <div :id="`collapse${incident.id}`" class="accordion-collapse collapse text-start">
    <div class="accordion-body">
      <div class="container-fluid p-0">
        <div class="row w-100">
          <div class="col"><KeyRound /> {{ incident.id }} </div>
          <div class="col"><SquareCheck /> <span class="badge rounded-pill" :class="incident.is_resolved ? 'bg-success' : 'bg-danger'"> {{ incident.is_resolved ? 'Resuelto' : 'Pendiente' }}</span> </div>
          <div class="col"><UserRound /> {{ incident.client_name }} </div> 
        </div>
        <div class="row w-100">
          <div class="col"><Store /> {{ incident.expendeduria_name }} </div>
          <div class="col"><CalendarClock /> {{ formatDateTime(incident.incident_date, incident.incident_time) }} </div>
          <div class="col"><Phone /> {{ incident.client_phone }}</div>
        </div>
        <div class="row w-100">
          <div class="col"><Calculator /> {{ incident.maquina_name }}</div>
          <div class="col"><CalendarClock /> {{ formatDateTime(incident.resolution_date, incident.resolution_time) }} </div>
          <div class="col"></div>
        </div>
        <div class="row w-100">
          <div class="col"><wrench /> {{ incident.operator_name }}</div>
          <div class="col"></div>
          <div class="col"></div>
        </div>
        <div class="row">
          <div class="incident-details mx-2 mt-3">
            <h5>Descripción:</h5>
              <!-- <div class="description-text">{{ incident.description }}<</div> -->
              <pre class="description-text">{{ incident.description }}</pre>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-end">
            <button class="btn btn-sm btn-outline-primary" @click="openEditFormModal(incident)">
              <Pencil />
              Editar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <IncidentFormComponent 
    :show="isEditFormModalOpen"
    :incident="editingIncident"
    @close="handleCloseEditFormModal"
    @submit="handleSubmitEditFormModal"
  />

</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Incident } from '@/types/incidentsTypes';
import { defineProps } from 'vue';
import { useIncidentStore } from '@/stores/useIncidentStore';
import { Pencil, Square } from 'lucide-vue-next';

import { Wrench, UserRound, Phone, CalendarClock } from 'lucide-vue-next';
import { Calculator, Store, SquareCheck, KeyRound } from 'lucide-vue-next';

import IncidentFormComponent from './IncidentFormComponent.vue';

const props = defineProps<{ incident: Incident; }>();
const incidentStore = useIncidentStore();

const isEditFormModalOpen = ref(false);
const editingIncident = ref<Incident | null>(null);

// Función para formatear la fecha y la hora
const formatDateTime = (date: string | null | undefined, time: string | null | undefined): string => {
  if (!date) return "N/A";

  let formattedDate = new Date(date).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  
  let formattedTime = time ? time.slice(0, 5) : "";

  return time ? `${formattedDate} ${formattedTime}` : formattedDate;
};

const openEditFormModal = (incident: Incident) => {
  console.log("Operator Name: " + incident.operator_name)
  editingIncident.value = incident;
  isEditFormModalOpen.value = true;
};

const handleCloseEditFormModal = () => {
  editingIncident.value = null;
  isEditFormModalOpen.value = false;
};

const handleSubmitEditFormModal = async () => {
  await incidentStore.fetchIncidents();
};

</script>

<style scoped lang="scss">
.bordered-img {
    border: 3px solid rgb(154, 194, 255);
    /* Puedes cambiar el color y grosor del borde */
    border-radius: 10px;
    /* Opcional: agrega esquinas redondeadas */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Opcional: agrega sombra para un efecto de elevación */
    margin: 10px;
    /* Opcional: agrega un margen alrededor de la imagen */
}

.incident-details {
    //margin-top: 10px;
    //padding: 10px;
    //background-color: #f9f9f9;
    //border: 1px solid #ddd;
    //border-radius: 5px;
    text-align: left;

    /* h5 {
      font-size: 1.1rem;
      font-weight: 600;
      margin-bottom: 8px;
    } */

    h6 {
      font-size: 1rem;
      font-weight: 500;
      margin-top: 10px;
    }

    h5 {
    color: #2c3e50;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
  }

  p, pre {
    &::first-line {
      font-weight: 500;
    }
    
    &:empty::before {
      content: "No hay descripción disponible";
      color: #999;
      font-style: italic;
    }
  }

    pre.description-text {
    white-space: pre-wrap; /* Conserva formato original y hace wrap */
    word-break: break-word; /* Evita overflow horizontal */
    font-family: inherit; /* Mantiene fuente del sistema */
    font-size: 0.9rem;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    line-height: 1.5;
    color: #333;
  }
  }

</style>
